
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mkszhecdhfgdzzlwwecv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1rc3poZWNkaGZnZHp6bHd3ZWN2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk0NjI5NDMsImV4cCI6MjA1NTAzODk0M30.5hyUApKhD5NB5OrGWcKbbJDNMP_PlF8jLSwtgUYyk-g";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
